import React from 'react';
import LoadingSpinner from './loadingSpinner'
import C18Input00 from './C18Input00'
import C18Select00 from './C18Select00'
import C18Select01 from './C18Select01'
import C18Button00 from './C18Button00'
import IconButton from '@material-ui/core/IconButton';
import Camera from '@material-ui/icons/Camera';
import {loadSitesInfo,getSiteInfo,getSiteIndex,getZoneIndex,loadZonesInfo,addToAdminLog} from './C18utils'
import {wsTrans, doGetPostBasic} from '../utils/utils'
import {cl, globs, constant, getRandomString,getTime, allStates,
  allCountries,allTimezones,
} from '../../components/utils/utils';
import history from "../../history"
import C18Confirm00 from './C18Confirm00'
import { withRouter } from 'react-router-dom';
class C18ManageSites extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      siteAddName:"",
      update:0,
      popup:{
        opacity:0,
        text:"Are you sure?",
        buttons:["Close"],
        resolve:null,
      },
    }
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveSites)
    this.props.parms.onChange({cmd:"savePage", data:{savePage:true}})
    this.loadInfo()
    this.setBreadCrumbs()
  }
  
  componentWillUnmount=()=>{
    this.subscribe_savePageEvent.remove()
  }
  
  setBreadCrumbs=()=>{
    if(this.props.parms){
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:"Admin", url:`/usa/c18/admin`},
              {t:"Manage Sites", url:`/usa/c18/admin/manageSites2`},
            ]},
        },
      )
    }
  }
  
  loadInfo=async()=>{
    await loadSitesInfo()
    this.saveSitesInfo(false)
    await loadZonesInfo()
    let gsi=this.sitesInfo
//     cl(gsi)
    let siteSel=(gsi[0]||{}).siteId
    let site=gsi[0]||{}
//     cl(site)
    const { state: locstate } = this.props.location;
    if (locstate && locstate.from) {
      console.log("Navigated from:", locstate.from);
      const parts = locstate.from.split('/');
      if(parts[parts.length - 1] !== "sites") {
        siteSel = parts[parts.length - 1];
        site = gsi.find(site => site.siteId === siteSel);
      }
    }

    this.setState({loaded:true, siteSel:siteSel, weatherStation: site.weatherStation, siteImage:site.siteImage})
  }
  
  saveSiteInfoToDb=async(siteId,siteInfo)=>{
    let st=this.state
    let body={
        accountId:siteInfo.accountId,
        siteId:siteId,
        name:siteInfo.name,
        weatherStation:siteInfo.weatherStation,
        siteImage:siteInfo.siteImage,
        thoroughfare: siteInfo.thoroughfare,
        premise: siteInfo.premise,
        locality: siteInfo.locality,
        administrativeArea: siteInfo.administrativeArea,
        postalCode: siteInfo.postalCode,
        country: siteInfo.country,
        timeZone: siteInfo.timeZone,
        mapView: siteInfo.mapView,
      }
//     cl(body)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/sites", method: "update",
      sessionId: globs.userData.session.sessionId, body: body})
//     cl(res)
    let coord=res.data?.coordinates
    if(coord){
      siteInfo.coordinates=coord
      siteInfo.badAddr=res.data.badAddr
    }else{
      siteInfo.badAddr=true
    }
    this.setState({forceUpd:(st.forceUpd||0)+1})
    globs.events.publish("saveOK",true)
    
//     cl(siteInfo)
  }
  
  saveToAdminLog=(adds,o,n)=>{
//     cl(o)
//     cl(n)
    let addObj={
      userId:globs.userData.session.userId,
      siteId:o.siteId,
      time:Math.floor(getTime())
    }
    if (o.type == "addSite" || o.type == "deleteSite") {
      adds.push(
        Object.assign({},addObj,
        {
        action: o.type,
        oldVal: "",
        newVal: n,
      }))
      return
    }
    if(o.name!=n.name){
      adds.push(
        Object.assign({},addObj,
        {
        action:"siteName",
        oldVal:o.name,
        newVal:n.name,
      }))
    }
    if(o.weatherStation!=n.weatherStation){
//       cl([o.weatherStation, n.weatherStation])
      adds.push(
        Object.assign({},addObj,
        {
        action:"wStation",
        oldVal:globs.zonesInfo.info[getZoneIndex(o.weatherStation)]?.zoneName||"None",
        newVal:globs.zonesInfo.info[getZoneIndex(n.weatherStation)]?.zoneName||"None",
      }))
      // adds.push(
      //   Object.assign({},addObj,
      //   {
      //   action:"wStation",
      //   oldVal:o.weatherStation,
      //   zoneId:n.weatherStation,
      // }))
    }
    if(o.siteImage!=n.siteImage){
      adds.push(
        Object.assign({},addObj,
        {
        action:"siteImage",
        oldVal:o.siteImage,
        newVal:n.siteImage,
      }))
    }
    if(o.thoroughfare!=n.thoroughfare){
      adds.push(
        Object.assign({},addObj,
        {
        action:"siteStreet1",
        oldVal:o.thoroughfare,
        newVal:n.thoroughfare,
      }))
    }
    if(o.premise!=n.premise){
      adds.push(
        Object.assign({},addObj,
        {
        action:"siteStreet2",
        oldVal:o.premise,
        newVal:n.premise,
      }))
    }
    if(o.locality!=n.locality){
      adds.push(
        Object.assign({},addObj,
        {
        action:"siteCity",
        oldVal:o.locality,
        newVal:n.locality,
      }))
    }
    if(o.administrativeArea!=n.administrativeArea){
      adds.push(
        Object.assign({},addObj,
        {
        action:"siteState",
        oldVal:o.administrativeArea,
        newVal:n.administrativeArea,
      }))
    }
    if(o.postalCode!=n.postalCode){
      adds.push(
        Object.assign({},addObj,
        {
        action:"siteZip",
        oldVal:o.postalCode,
        newVal:n.postalCode,
      }))
    }
    if(o.country!=n.country){
      adds.push(
        Object.assign({},addObj,
        {
        action:"country",
        oldVal:o.country,
        newVal:n.country,
      }))
    }
    if(o.timeZone!=n.timeZone){
      adds.push(
        Object.assign({},addObj,
        {
        action:"timeZone",
        oldVal:o.timeZone,
        newVal:n.timeZone,
      }))
    }
    if(o.mapView!=n.mapView){
      adds.push(
        Object.assign({},addObj,
        {
        action:"siteMapView",
        oldVal:o.mapView,
        newVal:n.mapView,
      }))
    }
  }
  
  saveSitesInfo=(doSave)=>{// do Save, means save to db, not means copy current settings
    if(!doSave){this.sitesInfo=[]}
    let gsi=globs.sitesInfo.info
    let adminAdds=[]
    for(let i=0;i<gsi.length;i++){
      let s=this.sitesInfo[i]
      if(doSave){
//         cl(s.weatherStation)
        // cl(gsi[i])
        // cl(s)
//         cl(globs.zonesInfo.info[getZoneIndex(s.weatherStation)])
        if((gsi[i].name!=s.name)||
          (gsi[i].weatherStation!=s.weatherStation)||
          (gsi[i].siteImage!=s.siteImage)||
          (gsi[i].thoroughfare!=s.thoroughfare)||
          (gsi[i].premise!=s.premise)||
          (gsi[i].locality!=s.locality)||
          (gsi[i].administrativeArea!=s.administrativeArea)||
          (gsi[i].postalCode!=s.postalCode)||
          (gsi[i].country!=s.country)||
          (gsi[i].timeZone!=s.timeZone)||
          (gsi[i].mapView!=s.mapView)
          ){
            this.saveSiteInfoToDb(gsi[i].siteId,s)
            this.saveToAdminLog(adminAdds,gsi[i],s)
            gsi[i].name=s.name
            gsi[i].weatherStation=s.weatherStation
            gsi[i].siteImage=s.siteImage
            gsi[i].thoroughfare=s.thoroughfare
            gsi[i].premise=s.premise
            gsi[i].locality=s.locality
            gsi[i].administrativeArea=s.administrativeArea
            gsi[i].postalCode=s.postalCode
            gsi[i].country=s.country
            gsi[i].timeZone=s.timeZone
            gsi[i].mapView=s.mapView
//             cl(`update ${gsi[i].name}`)
          }
      }else{
        let s=gsi[i]
//         if(!s.timeZone){s.timeZone="America/Los_Angeles"}
        let ws = s.weatherStation
        if (!ws) {
          // set weather station to first matching zone if none assigned
//           for (let j = 0; j < globs.zonesInfo.info.length; j++) {
//             if(globs.zonesInfo.info[j].siteId==s.siteId){
//               ws = globs.zonesInfo.info[j].zoneId
//               gsi[i].weatherStation = ws
//               break
//             }
//           }
        }
//         cl(s)
        this.sitesInfo.push({
          siteId:s.siteId,
          name:s.name,
          weatherStation:ws,
          siteImage:s.siteImage,
          thoroughfare:s.thoroughfare,
          premise:s.premise,
          locality:s.locality,
          administrativeArea:s.administrativeArea,
          postalCode:s.postalCode,
          country:s.country,
          timeZone:s.timeZone,
          mapView:s.mapView,
          coordinates:s.coordinates,
          badAddr:s.badAddr,

        })
      }
    }
//     cl(adminAdds)
    if(doSave){addToAdminLog(adminAdds)}
  }
  
  saveSites=(cmd)=>{
    if(cmd=="save"){
      this.saveSitesInfo(true)
    }
//     history.goBack()
  }
  
  showSitesOpts=()=>{
    return this.sitesInfo.map((s,i)=>{
//       cl(s)
      return(
        <option key={i} value={s.siteId}>{s.name}</option>
      )
    })
  }
  
  showZoneOpts=()=>{
//     cl(globs.zonesInfo.info)
//     cl(this.state.siteSel)
//     return
    let zones=globs.zonesInfo.info.map((z,i)=>{
      if(z.siteId==this.state.siteSel){
        return(
          <option key={i} value={z.zoneId}>{z.zoneName}</option>
        )
      }
    })
    let noneArr=[<option key={"none"} value={""}>{"None"}</option>]
    return noneArr.concat(zones)
  }
  
  setSiteName=(siteId, siteName)=>{
    this.sitesInfo[getSiteIndex(siteId)].name=siteName
//     let gsi=this.sitesInfo
//     for(let i=0;i<gsi.length;i++){
//       if(gsi[i].siteId==siteId){
//         gsi[i].name=siteName
//         return
//       }
//     }
  }
  
  addSite=()=>{
    if(this.state.siteAddName){
      // cl(this.state.siteAddName)
      let siteId=getRandomString(16)
      let s={
        accountId:globs.userData.session.accountId,
        siteId:siteId,
        name:this.state.siteAddName,
      }
      globs.sitesInfo.info.push(s)
      this.sitesInfo.push(s)
//       cl(s)
      this.saveSiteInfoToDb(s.siteId,s)
      this.mySetState({siteSel:siteId,update:this.state.update+1})

      let adminAdds = []
      this.saveToAdminLog(adminAdds, {siteID: siteId, type: "addSite"}, this.state.siteAddName)
      // cl(adminAdds)
      addToAdminLog(adminAdds)
    }
  }
  
  deleteSite=async()=>{
    let res=await this.props.parms.getPopup({text:"Are you sure you want to delete this site?", buttons:["Cancel","Yes"]})
    if(res=="Yes"){
      let gsi=this.sitesInfo
      let siteId=this.state.siteSel
      let index=getSiteIndex(siteId)
      let name = gsi[index].name
      globs.sitesInfo.info.splice(index,1)
      gsi.splice(index,1)
      cl([siteId, name])
      
      wsTrans("usa", {cmd: "cRest", uri: "/s/sites", method: "delete", 
        sessionId: globs.userData.session.sessionId, body: {
          siteId: siteId,
        }})

      let adminAdds = []
      this.saveToAdminLog(adminAdds, {siteId: siteId, type: "deleteSite"}, name)
      addToAdminLog(adminAdds)

      let siteSel=gsi[0].siteId
      this.setState({siteSel:siteSel})
    }
  }
  
  mySetState=(vals)=>{
    this.setState(vals)
  }
  
  onChange=(type,vals)=>{
//     cl(type,vals)
    switch(type){
      case "upd":
        globs.events.publish("savePageEnable",true)
        Object.assign(this.sitesInfo[getSiteIndex(this.state.siteSel)],vals)
        this.mySetState(vals)
        break
      case "siteSel":
        this.mySetState(vals)
        break
      case "siteName":
        globs.events.publish("savePageEnable",true)
        this.setSiteName(this.state.siteSel,vals.siteName)
        this.mySetState(vals)
        break
      case "weatherStation":
//         cl(vals)
//         cl(this.sitesInfo[getSiteIndex(this.state.siteSel)])
//         cl(this.sitesInfo[getSiteIndex(this.state.siteSel)].weatherStation)
        globs.events.publish("savePageEnable",true)
//         this.setSiteName(this.state.siteSel,vals.siteName)
        Object.assign(this.sitesInfo[getSiteIndex(this.state.siteSel)],vals)
//         cl(this.sitesInfo)
        this.mySetState(vals)
        break
      case "siteImage":
        globs.events.publish("savePageEnable",true)
//         this.setSiteName(this.state.siteSel,vals.siteName)
        Object.assign(this.sitesInfo[getSiteIndex(this.state.siteSel)],vals)
        // cl(this.sitesInfo)
        this.mySetState(vals)
        break
      case "siteAddName":
        this.mySetState(vals)
        break
      case "addSite":
        this.addSite()
        break
      case "deleteSite":
        this.deleteSite()
        break
      default:
        break
    }
  }
  
  showSelectSite=()=>{
    return(
      <div className="custom-select">
        <label htmlFor="">Select Site</label>
        
        <C18Select00 id=""
          parms={{list:true}}
          value={this.state.siteSel}
          onChange={e=>this.onChange("siteSel",{siteSel: e.currentTarget.value})}
        >
          {this.showSitesOpts()}
        </C18Select00>
        {false&&
          <span className="material-icons down-arrow">
            keyboard_arrow_down
          </span>
        }
      </div> 
    )
  }
  
  showSelectWeatherStation=()=>{
//     cl(this.sitesInfo)
    let index=getSiteIndex(this.state.siteSel)
    let gsi=globs.sitesInfo.info
    let siteInfo=this.sitesInfo[index]||{}
    let weatherStation=siteInfo.weatherStation
//     cl(weatherStation)
    return(
      <div className="custom-select">
        <label htmlFor="">Weather Station</label>
        <C18Select00 id=""
          value={weatherStation}
          onChange={e=>this.onChange("weatherStation",{weatherStation: e.currentTarget.value})}
        >
          {this.showZoneOpts()}
        </C18Select00>
        <span className="material-icons down-arrow">
          keyboard_arrow_down
        </span>
      </div>
      
    )
  }

  resolvePopup=(e)=>{
    //     cl(e)
        let popup=this.state.popup
        popup.opacity=0
        this.setState({popup:popup})
        // if(resolve){resolve(e)}
        // cl(this.state.popup)
  }
  
  markImage=async(e)=>{
    
    cl(e.target.files)
    let files=e.target.files[0]
    if (!files) return
    if ((files.size > (2097152) ) || (!files.type.startsWith("image/"))) {
      cl(this.state.popup)
      let popup={
        opacity:1,
        text:"File must be an image and smaller than 2MB!",
        buttons:["Close"],
        resolve:e=>this.resolvePopup(e),
      }
      this.setState({popup:popup})
      return
    } 

    let imageId= getRandomString(16)
    let ext=files.name.substr(files.name.lastIndexOf('.')+1)
    let data = new FormData()
    data.append("type", "site")
    data.append("sessionId", globs.userData.session.sessionId)
    data.append('file', files)
    data.append('id', imageId)
    let url=`${constant.expressUrl}/usa/images`
    let method="POST"
    let type="multipart/form-data"
    cl("post image")
    let ret=await doGetPostBasic(url, method, data, type)
    let ret2 = await ret.json()
    this.onChange("siteImage",{siteImage: `${imageId}.${ext}`})
    
    this.setState({siteImage: `${imageId}.${ext}`})
  }
  

  
  showSiteImage=(siteImage)=>{
//     cl(this.state.avatar)
    // let av=this.state.avatar
//       <div>
//         <IconButton
//           variant="contained"
//           component="label"
//           title="Upload Image"
//         >
//           <Camera/>
//           <C18Input00 hidden multiple type="file" onChange={this.markImage}/>
//         </IconButton>
//       </div>
    var path
//     cl(siteImage);
    if(siteImage){
      let si=siteImage.split('.')[0];
      let ext=siteImage.split('.')[1];
      path=`${constant.expressUrl}/usa/images/site/uploads/${si[0]}/${si[1]}/${si[2]}/${si.substr(3)}.${ext}`
    }else{
      path=`${constant.expressUrl}/usa/images/avatars/stockAvatar.jpg`
    }
    return(
      <div>
      <div style={{height: 20}}/>
      
      <h3 style={{display: "inline-block"}}>Site Image</h3>
      <div/>
      <img width="240" src={path} style={{padding: 10}}/>
      </div>
    )
  }

  showCountry=(siteInfo)=>{
    let st=this.state
//     cl(st)
    let opts=allCountries.map(c=>{
      return {v:c.cca3,t:c.country}
    })
    return(
      <C18Select01 parms={{
        label:"Country",
        valueName:"country",
        country:siteInfo.country,
        opts:opts,
        onChange:(e,v)=>{this.onChange("upd",v)}//this.onChange,
      }}/>

    )
  }

  showTimeZone=(siteInfo)=>{
    let st=this.state
//     cl(st)
    let allTz=allTimezones.slice(0)
    allTz.splice(5,0,"America/Phoenix")// workaround
//     cl(allTz)
    let opts=allTz.map(t=>{
      return {v:t,t:t}
    })
    return(
      <C18Select01 parms={{
        label:"TimeZone",
        valueName:"timeZone",
        timeZone:siteInfo.timeZone,
        opts:opts,
        onChange:(e,v)=>{this.onChange("upd",v)}//this.onChange,
      }}/>

    )
  }

  showLatLng=(siteInfo)=>{
    let st=this.state
//     cl(st)
//     cl(siteInfo)
    if(siteInfo.badAddr){
      return(<span>Location Not Geocoded<br/><br/></span>)
    }
    let coord=siteInfo.coordinates?.coords
    if(coord){
//       cl(coord)
//       cl(coord.lat)
//       cl(coord.lat.toFixed(2))
      let alt=(coord.alt)?`, Alt: ${(coord.alt.toFixed(0)*3.28).toFixed(0)} ft`:""
      return(
        <span>
        Lat: {coord.lat.toFixed(2)},
        Lng: {coord.lng.toFixed(2)}
        {alt}
        <br/><br/></span>
      )
    }
  }

  showAddress=()=>{
    let index=getSiteIndex(this.state.siteSel)
    let siteInfo=this.sitesInfo[index]||{}
    // cl(siteInfo)
    return(
      <>
        <br/>
        <label htmlFor="account-street1">Street 1</label>
        <C18Input00 id="account-street1" type="text" maxLength="50"
          value={siteInfo.thoroughfare||""}
          onChange={e=>this.onChange("upd",{thoroughfare:e.currentTarget.value})}
        />
        <br/>

        <label htmlFor="account-street2">Street 2</label>
        <C18Input00 id="account-street2" type="text" maxLength="50"
          value={siteInfo.premise||""}
          onChange={e=>this.onChange("upd",{premise:e.currentTarget.value})}
        />
        <br/>

        <label htmlFor="account-city">City</label>
        <C18Input00 id="account-city" type="text" maxLength="50"
          value={siteInfo.locality||""}
          onChange={e=>this.onChange("upd",{locality:e.currentTarget.value})}
        />
        <br/>

        <label htmlFor="account-state">State</label>
        <span className="custom-select">
          <select id="account-state"
            value={(siteInfo.administrativeArea) ? siteInfo.administrativeArea : "default"}
            onChange={e=>this.onChange("upd",{administrativeArea:e.currentTarget.value})}
          >
            <option key={0} disabled hidden value="default"> -- select an option -- </option>
            {allStates.map((st,i)=>{
              return(
                <option key={i} value={st}>{st}</option>
              )
            })}
          </select>
          <span className="material-icons down-arrow">
            keyboard_arrow_down
          </span>
        </span>
        <br/>

        <label htmlFor="account-zip">Zip</label>
        <C18Input00 id="account-zip" type="text" maxLength="10"
          value={siteInfo.postalCode||""}
          onChange={e=>this.onChange("upd",{postalCode:e.currentTarget.value})}
        /><br/>
      {this.showCountry(siteInfo)}<br/>
      {this.showTimeZone(siteInfo)}<br/>
      </>
    )
  }
  
//   showOptions=()=>{
//     let st=this.state
//     let index=getSiteIndex(this.state.siteSel)
//     let siteInfo=this.sitesInfo[index]||{}
//     return(
//       <div>
//       <h3>Options</h3>
//       <input
//         id="MapView" style={{display:"inline-block"}}
//         type="checkBox"
//         checked={siteInfo.mapView||false}
//         name="MapView"
//         onChange={e=>{}}
//         onClick={e=>this.onChange("upd",{mapView:e.currentTarget.checked})}
//         />&nbsp;
//       <label htmlFor="MapView" style={{display:"inline-block"}}>Map View</label>
//       </div>
//     )
//   }

  render(){
    if(this.state.loaded){
//       cl(this.state.siteSel)
      let index=getSiteIndex(this.state.siteSel)
      let siteInfo=this.sitesInfo[index]||{}
//       let siteInfo=getSiteInfo(this.state.siteSel)
      let siteName=siteInfo.name
      let siteImage=siteInfo.siteImage
//       cl(siteName)
      return(
        <div>
          <C18Confirm00 parms={this.state.popup}/>
          {this.showSelectSite()}
          <div>
            <C18Button00 type="button" className="danger" onClick={()=>this.onChange("deleteSite")}>Delete</C18Button00>
          </div>
          
          <p>Site ID: {this.state.siteSel}</p>
          {this.showLatLng(siteInfo)}
          <label htmlFor="site-name">Site Name</label>
          <C18Input00 type="text" id="site-name" 
            value={siteName}
            maxLength="50"
            onChange={e=>this.onChange("siteName",{siteName:e.currentTarget.value})}
          />

          {this.showAddress()}

          <br />
          {this.showSelectWeatherStation()}

          <br />
          <div style={{position:"relative"}}>
            <C18Button00 type="button" className="icon" style={{
              width:200,
              height:40,
              display:"block",
            }}>
              Upload Site Image
              <span className="material-icons-outlined">
                upload_file
              </span>
            </C18Button00>

            <C18Input00 type="file"  onChange={this.markImage} style={{
              position:"absolute",
              top:0,
              width:200,
              height:40,
              marginTop:0,//-40,
              zIndex:10,
              opacity:0,
              cursor: "pointer",
            }}/>
          </div>

          <p>File must be an image and smaller than 2MB.</p>
          {this.showSiteImage(siteImage)}
          <p>Add Site</p>
          <label htmlFor="site-name">Site Name</label>
          <C18Input00 type="text" id="site-add-name" className="with-right-button" 
            value={this.state.siteAddName}
            maxLength="50"
            onChange={e=>this.onChange("siteAddName",{siteAddName:e.currentTarget.value})}
          />
          <C18Button00 type="button" className="outlined"
            onClick={e=>this.onChange("addSite")}>Add Site</C18Button00>
        </div>
      )
      
    }else{
      return <LoadingSpinner message="Loading..." />
    }
//       let zoneInfo=getZoneInfo(this.state.zoneSel)
  }
}
      
export default withRouter(C18ManageSites);
